<mat-expansion-panel [expanded]="true">

  <mat-expansion-panel-header class="card-header">
    <mat-panel-title class="text-style">
      <mat-icon style="margin-top: -3px;">assignment</mat-icon> Datos de Comparativa de Materiales
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-container *ngIf="canEdit">

    <br/>
    
    <ng-container *ngIf="!(pedidoItemList != null && pedidoItemList.length > 0)">
      <mat-label><b>No hay materiales cargados en el pedido.</b></mat-label>
    </ng-container>

    <ng-container *ngIf="pedidoItemList != null && pedidoItemList.length > 0">

      <ng-container *ngFor="let pedidoItem of pedidoItemList">

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <b style="margin-right: 3px;">MATERIAL:</b> {{pedidoItem.MaterialNombre}} {{pedidoItem.Detalle?.length > 0 ? (' - ' + pedidoItem.Detalle) : ''}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <button mat-raised-button (click)="onAgregarProveedor(pedidoItem)" color="primary"
                class="zb-button">Agregar Oferente</button>
            </div>

          </div>

          <ng-container *ngIf="presupuestosList[pedidoItem.Id].Proveedores != null && presupuestosList[pedidoItem.Id].Proveedores.length > 0">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngFor="let itemProveedor of presupuestosList[pedidoItem.Id].Proveedores">

              <div fxFlex=5 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <a style="cursor: pointer; margin-right: 15px; margin-left: 18px;" (click)="deleteProveedor(pedidoItem.Id, itemProveedor.Id)" title="Eliminar proveedor">
                  <i class="fa fa-trash fa-1x"></i> 
                </a>
              </div>

              <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                <form [formGroup]="itemProveedor.ProveedorFormGroup">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <input type="text" placeholder="Proveedor*" aria-label="Proveedor" matInput [matAutocomplete]="proveedor" formControlName="Proveedor">
                    <i [ngStyle]="{'display': itemProveedor.IsProveedorAutoSearching ? 'inline-block' : 'none'}"
                      class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                      <mat-error *ngIf="!itemProveedor.ProveedorFormGroup?.controls['Proveedor'].valid && itemProveedor.ProveedorFormGroup?.controls['Proveedor'].touched">
                        {{ getErrorProveedor() }}
                      </mat-error>
                  </mat-form-field>
                  <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor" (optionSelected)="onProveedorSelect(itemProveedor)">
                    <mat-option *ngFor="let s of itemProveedor.FilteredProveedorList" [value]="s">
                      {{s.RazonSocial }}
                    </mat-option>
                  </mat-autocomplete>
                </form>
              </div>

              <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="text-align: center;">
                <mat-checkbox [(ngModel)]="itemProveedor.EsVariante" color="primary" title="Es una variante al material del pedido?"></mat-checkbox>
                <br/>Es<br/>Variante?
              </div>

              <ng-container *ngIf="itemProveedor.EsVariante">

                <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                  <form [formGroup]="itemProveedor.MaterialFormGroup">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <input type="text" placeholder="Material" aria-label="Material" matInput [matAutocomplete]="material" formControlName="Material">
                      <!-- <i class="fa fa-spinner fa-spin" *ngIf="itemProveedor.IsMaterialAutoSearching"></i> -->
                      <mat-autocomplete #material="matAutocomplete" [displayWith]="displayMaterial" (optionSelected)="onMaterialSelect(itemProveedor)">
                        <mat-option *ngFor="let s of itemProveedor.FilteredMaterialList" [value]="s">
                          {{s.Nombre}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </form>
                </div>

                <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <input matInput type="text" [(ngModel)]="itemProveedor.Detalle" placeholder="Detalle" title="Detalle">
                  </mat-form-field>
                </div>

              </ng-container>

              <div fxFlex=10 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <input matInput type="number" [(ngModel)]="itemProveedor.Cantidad" (change)="updateProveedoresList()"
                    placeholder="Cantidad" title="Cantidad">
                </mat-form-field>
              </div>

              <div fxFlex=20 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-select [(ngModel)]="itemProveedor.MonedaId" placeholder="Moneda" title="Moneda">
                    <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=15 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <input matInput type="number" [(ngModel)]="itemProveedor.MontoUnitario" (change)="updateProveedoresList()"
                    placeholder="Monto Unitario" title="Monto Unitario">
                </mat-form-field>
              </div>

              <div fxFlex=15 fxFlex.xs=100 class="flex-item" style="margin-top: 20px; text-align: right;">
                {{(itemProveedor.Cantidad * itemProveedor.MontoUnitario) | number:'1.2-2'}}
              </div>

              <hr style="margin: 5px 0px; width: 100%;">

            </div>
            
          </ng-container>

        </mat-expansion-panel>

        <br/>

      </ng-container>

    </ng-container>

  </ng-container>

</mat-expansion-panel>

<br/>

<mat-expansion-panel [expanded]="true">
  
  <mat-expansion-panel-header class="card-header">
    <mat-panel-title class="text-style">
      <mat-icon style="margin-top: -3px;">assignment</mat-icon> Datos de Presupuestos de Oferentes
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-container *ngIf="canEdit && proveedorList != null && proveedorList.length > 0">

    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngFor="let proveedor of proveedorList" style="margin-top: 10px; font-weight: bold;">

      <div fxFlex=40 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Razón Social</b>: {{proveedor?.RazonSocial}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=20 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Subtotal</b>: {{proveedor.Subtotal | number: '1.2-2'}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>
      <div fxFlex=20 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label *ngIf="!isAlicuotaIvaSearching">IVA{{tenantFeatureFlags?.HabilitarControlCaja ? "*" : ""}}</mat-label>
          <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
          <mat-select [(ngModel)]="proveedor.AlicuotaIva">
            <mat-option *ngFor="let s of alicuotaIvaList" [value]="s">{{s.Nombre}}</mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
            {{ getErrorAlicuotaIva() }}
          </mat-error> -->
        </mat-form-field>
      </div>
      <div fxFlex=20 fxFlex.xs=100 class="flex-item">
        <mat-expansion-panel [expanded]="true" hideToggle="true">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-label><b>Total</b>: {{(proveedor.Subtotal * (1 + (proveedor.AlicuotaIva != null ? proveedor.AlicuotaIva.Porcentaje : 0) / 100)) | number: '1.2-2'}}</mat-label>
          </div>
        </mat-expansion-panel>
      </div>

      <div fxFlex=30 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label *ngIf="!isFormaPagoSearching">Formas de Pago*</mat-label>
          <mat-label *ngIf="isFormaPagoSearching">Cargando...</mat-label>
          <mat-select multiple [(ngModel)]="proveedor.FormaPagoId">
            <mat-option *ngFor="let s of formaPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="!formGroup.controls['FormaPagoId'].valid  && formGroup.controls['FormaPagoId'].touched">
            {{ getErrorFormaPago() }}
          </mat-error> -->
        </mat-form-field>
      </div>
      <div fxFlex=30 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label *ngIf="!isTipoCompraSearching">Tipo de Compra*</mat-label>
          <mat-label *ngIf="isTipoCompraSearching">Cargando...</mat-label>
          <mat-select [(ngModel)]="proveedor.TipoCompra">
            <mat-option *ngFor="let s of tipoCompraList" [value]="s.Id">{{s.Nombre}}</mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="!formGroup.controls['TipoCompra'].valid && formGroup.controls['TipoCompra'].touched">
            {{ getErrorTipoCompra() }}
          </mat-error> -->
        </mat-form-field>
      </div>
      <div fxFlex=30 fxFlex.xs=100 class="flex-item" style="margin-top: 15px;">
        <mat-checkbox [(ngModel)]="proveedor.IncluyeFlete" [ngModelOptions]="{standalone: true}" color="primary">Incluye Flete
        </mat-checkbox>
      </div>

      <hr style="margin: 5px 0px; width: 100%;">

    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px; font-weight: bold;">
      <div fxFlex=90 fxFlex.xs=100 class="flex-item">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label class="text-style" *ngIf="comprobanteFile; else newFile">{{selectedFile}}</mat-label>
          <ng-template #newFile>
            <mat-label class="text-style">Adjuntar archivo</mat-label>
          </ng-template>
          <input matInput disabled>
          <button mat-icon-button matSuffix (click)="fileInput.click()">
            <mat-icon>attach_file</mat-icon>
          </button>
          <input hidden (change)="selectFile($event)" #fileInput type="file">
        </mat-form-field>
      </div>
      <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
        <a style="cursor: pointer; margin-right: 15px; margin-left: 18px;" (click)="deleteFile()" title="Eliminar adjunto">
          <i class="fa fa-trash fa-1x"></i> 
        </a>
      </div>
    </div>

  </ng-container>

</mat-expansion-panel>

<mat-card-actions style="margin-bottom: 10px;">
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="onGuardarPresupuesto()" color="primary" *ngIf="canEdit"
      class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
    <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">
      {{canEdit ? 'Cancelar' : 'Cerrar'}}
    </button>
  </div>
</mat-card-actions>
